var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"height":"20","width":"20","icon":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.copy($event)}}},[_c('v-img',{attrs:{"contain":"","height":"14","src":_vm.copyIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }